/* eslint-disable no-underscore-dangle */
import { ChainDeploymentStatus, DeploymentStatus } from '@/graphql';
import {
  WorkspaceChainFragment,
  WorkspaceChainPrimaryDeploymentFragment,
} from '@/sections/Overview/Chains/__generated__/fragments.generated';
import {
  WorkspaceModelFragment,
  WorkspacePrimaryVersionFragment,
} from '@/sections/Overview/Models/__generated__/fragments.generated';

import { mapDeploymentStatusToFilter } from './constants';
import { Filter, WorkspaceSections } from './types';

function getPrimaryStatus(
  primary?: WorkspacePrimaryVersionFragment | WorkspaceChainPrimaryDeploymentFragment,
): DeploymentStatus | ChainDeploymentStatus | null {
  if (!primary) return null;

  return primary.__typename === 'ModelVersionType'
    ? primary.currentModelDeploymentStatus.status
    : primary.status;
}

function filterChainsByStatus(chains: WorkspaceChainFragment[], type: Filter) {
  switch (type) {
    case Filter.All:
      return chains;
    case Filter.RUNNING: // "Running" means the entity is costing the user money.
      return chains.filter((chain) => {
        const countsByStatus = chain.deploymentCountByStatus;

        return countsByStatus.some(
          ({ status, count }) => mapDeploymentStatusToFilter[status] === type && count > 0,
        );
      });
    case Filter.SCALED_TO_ZERO:
    case Filter.INACTIVE:
    case Filter.FAILED:
      return chains.filter(
        (chain) => mapDeploymentStatusToFilter[chain.primaryDeployment.status] === type,
      );
  }
}

function filterModelsByStatus(models: WorkspaceModelFragment[], type: Filter) {
  switch (type) {
    case Filter.All:
      return models;
    case Filter.RUNNING: // "Running" means the entity is costing the user money.
      return models.filter((model) => {
        const countsByStatus = model.versionCountByStatus;

        return countsByStatus.some(
          ({ status, count }) => mapDeploymentStatusToFilter[status] === type && count > 0,
        );
      });
    case Filter.SCALED_TO_ZERO:
    case Filter.INACTIVE:
    case Filter.FAILED:
      return models.filter(
        (model) =>
          mapDeploymentStatusToFilter[model.primaryVersion.currentModelDeploymentStatus.status] ===
          type,
      );
  }
}

const mapSectionToTitle = {
  [WorkspaceSections.ModelAPIs]: 'Model APIs',
  [WorkspaceSections.Chains]: 'Chains',
  [WorkspaceSections.Training]: 'Training',
  [WorkspaceSections.Models]: 'Models',
  [WorkspaceSections.Overview]: 'Overview',
};

export { getPrimaryStatus, filterChainsByStatus, filterModelsByStatus, mapSectionToTitle };
